import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../../api/apiService";
import { Spinner } from "react-bootstrap";
import { getBadgeClass } from "../../config/utils";

function PrintEmployeeMonthlyAttend() {
    const [searchParams] = useSearchParams();
    const employeeId = searchParams.get("id");
    const month = searchParams.get("month");
    const year = searchParams.get("year");
    const company = localStorage.getItem("company");

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchAttendanceReport = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`employee/report-json/${employeeId}?month=${month}&year=${year}`);
                setData(response.data);
            } catch (err) {
                console.error("Error fetching attendance report:", err);
                toast.error("Failed to fetch data")
            } finally {
                setIsLoading(false);
            }
        };

        fetchAttendanceReport();
    }, [employeeId, month, year]);

    useEffect(() => {
        if (!isLoading) {
            setTimeout(() => {
                window.print();
                window.addEventListener("afterprint", handleAfterPrint);
            }, 1000);
        }
        return () => {
            window.removeEventListener("afterprint", handleAfterPrint);
        };
    }, [isLoading]);

    const handleAfterPrint = () => {
        window.close();
    };

    const { employee, stats, total_hours, attendance_records } = data || {};

    return (
        <div className="text-dark" style={{ padding: "20px" }}>
            <h2 style={{ textAlign: "center" }}>Employee Attendance Report</h2>
            {employee?.name && <h3 style={{ textAlign: "center" }}>{employee.name}</h3>}

            <p>
                <strong>Month:</strong>{" "}
                {new Date(year, month - 1).toLocaleString("default", { month: "long" })}{" "}
                <strong>Year:</strong> {year}
            </p>

            {stats && (
                <p>
                    <strong>Present:</strong> {stats.present || 0} | <strong>Absent:</strong> {stats.absent || 0} |
                    {total_hours > 0 && <span> <strong>Total Hours:</strong> {total_hours} hours</span>}
                </p>
            )}

            {employee?.shift && (
                <p>
                    <strong>Assigned Shift:</strong> {employee.shift.shift_name} |
                    <strong> Shift Start:</strong> {employee.shift.start_time} |
                    <strong> Shift End:</strong> {employee.shift.end_time}
                </p>
            )}

            {isLoading ? (
                <div className="text-center mt-3">
                    <Spinner animation="border" variant="primary" />
                    <span className="ms-2">Loading...</span>
                </div>
            ) : attendance_records?.length > 0 ? (
                <div className="table-responsive mb-3">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Check In</th>
                                <th>Check Out</th>
                                <th>Total Hours</th>
                                <th>Check In Status</th>
                                <th>Check Out Status</th>
                                <th>Approved</th>
                                {/* <th>Created By</th> */}
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {attendance_records.map((record, index) => (
                                <tr key={index}>
                                    <td>{record.date}</td>
                                    <td>{record.check_in || '--'}</td>
                                    <td>{record.check_out || '--'}</td>
                                    <td>{record.total_hours} hours</td>
                                    <td>
                                        <span className={`text-${getBadgeClass(record.check_in_status)}`}>
                                            {record.check_in_status}
                                        </span>
                                    </td>
                                    <td>
                                        {record.check_out_status ? (
                                            <span className={`text-${getBadgeClass(record.check_out_status)}`}>
                                                {record.check_out_status}
                                            </span>
                                        ) : (
                                            '--'
                                        )}
                                    </td>
                                    <td>
                                        <span className={`text-${record.approved ? 'success' : 'danger'}`}>
                                            {record.approved ? 'Yes' : 'No'}
                                        </span>
                                    </td>
                                    {/* <td>{record.created_by || '--'}</td> */}
                                    <td>{record.remarks || '--'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <tbody>
                    <tr>
                        <td colSpan="9" className="text-center">No attendance records found.</td>
                    </tr>
                </tbody>
            )}

            {!isLoading && <h5>{company}</h5>}
        </div>
    );
}

export default PrintEmployeeMonthlyAttend;
